module.exports = __webpack_public_path__ + "static/media/ico_plus_white.0a8c088f.svg";